import type { BoxProps, SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { forwardRef } from 'react'

// WebKit ignores opacity on scrollbar pseudo-elements, hence the background-color fade.
export const hoverScrollbarSx = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease-in-out',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
  '&:hover': {
    scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
  },
} satisfies SxProps<Theme>

export const ScrollArea = forwardRef<HTMLDivElement, BoxProps>(
  ({ sx, ...props }, ref) => (
    <Box
      ref={ref}
      {...props}
      // The array form deep-merges caller sx.
      sx={[
        {
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          // A grid child that clips overflow has a zero automatic minimum size, so auto rows would squash it.
          gridAutoRows: 'max-content',
        },
        hoverScrollbarSx,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  )
)

ScrollArea.displayName = 'ScrollArea'

// Declared at module level: a new identity each render would remount a Virtuoso list.
export const VirtuosoScroller = forwardRef<HTMLDivElement, BoxProps>(
  (props, ref) => <Box {...props} ref={ref} sx={hoverScrollbarSx} />
)

VirtuosoScroller.displayName = 'VirtuosoScroller'
